import React, { useEffect } from "react";
import ModalLoadingFull from "../modals/ModalLoadingFull";
import { useNavigate, useParams } from "react-router";
import { postNotification } from "./Notifications";

export default function Redirect(props) {
  const { path, message, replace, useWindow } = props;

  const navigate = useNavigate();
  const params = useParams();

  // Redirects to the specified path
  useEffect(() => {
    let newPath = path;

    // Replaces any path params with their respective values
    if (path) {
      const keys = Object.keys(params);

      keys.forEach((key) => {
        newPath = newPath.replace(`:${key}`, params[key]);
      });
    }

    if (useWindow) {
      window.location.href = newPath;
    }
    // Navigates to the new path, replacing the current path if specified
    navigate(newPath || "/", { replace: Boolean(replace) });

    if (message) {
      postNotification("warning", message);
    }
    // eslint-disable-next-line
  }, [path]);

  return <ModalLoadingFull />;
}
